import { useMemo } from "react";

import { useMessengerStoreMainStreamFetchState } from "./__internal__/useMessengerStoreMainStreamFetchState";

export const useMessengerStoreHasConversations = (): {
  hasConversations: boolean;
} => {
  const { mainStreamFetchState } = useMessengerStoreMainStreamFetchState();
  const hasConversations = useMemo(
    () => (mainStreamFetchState?.conversationByUserToken.size ?? 0) > 0,
    [mainStreamFetchState?.conversationByUserToken.size]
  );
  return { hasConversations };
};
